import axios from 'axios';

import { API_URL } from '../../router/constants/constants';
import { BuildingDto } from '../../types/dto/building.dto';
import { Location } from '../../types/enum/location';

export class Buildings {
  async getBuildings(): Promise<BuildingDto[]> {
    const response = await axios({
      method: 'GET',
      url: `${API_URL}/api/admin/buildings`,
      responseType: 'json',
    });

    return response.data;
  }

  async getBuildingById(buildingId: string): Promise<BuildingDto> {
    const response = await axios({
      method: 'GET',
      url: `${API_URL}/api/admin/buildings/${buildingId}`,
      responseType: 'json',
    });

    return response.data;
  }

  async updateBuildingLocation(buildingId: string, location: Location) {
    return await axios({
      method: 'PATCH',
      url: `${API_URL}/api/admin/buildings/${buildingId}`,
      responseType: 'json',
      data: { location },
    });
  }
}
